import { makeStyles } from '@material-ui/core'
import { FC } from 'react'
import progressStart from '../../images/progressStart.svg'
import progressSuccess from '../../images/progressSuccess.svg'
import updateProgressStart from '../../images/updateProgressStart.svg'

const useStyles = makeStyles({
    icons: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px 0 5px 0',
        '& img': {
            width: '25px'
        },
        '& > svg': {
            color: 'gray'
        }
    },
    progressWrapper: {
        position: 'relative',
        overflow: 'hidden'
    },
    line: {
        backgroundColor: 'rgb(192, 192, 192)', // 'gray',
        width: '100%',
        height: '1px',
        margin: '10px 0'
    },
    progress: {
        position: 'absolute',
        backgroundColor: 'rgb(106, 168, 79)', // 'green',
        width: 0,
        height: '3px',
        margin: '8px 0',
        top: 0
    },
    stepsContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    stepNumber: {
        fontFamily: 'CircularBold',
        fontSize: '1.25rem',
        marginRight: '17px'
    },
    currentStep: {
        color: '#4F9B44'
    },
    grayText: {
        color: '#D2D6DB'
    }
})

interface Props {
    currentStep?: number
    progress: number
    updateType?: boolean
    showStepNumbers?: boolean
}

const NewApplicationProgress: FC<Props> = ({
    currentStep = 0,
    progress,
    updateType,
    showStepNumbers
}) => {
    const styles = useStyles()

    return (
        <div>
            <div className={styles.icons}>
                <img
                    src={updateType ? updateProgressStart : progressStart}
                    alt={'Stepper start icon'}
                />
                <div className={styles.stepsContainer}>
                    {showStepNumbers && (
                        <div className={styles.stepNumber}>
                            <span className={styles.currentStep}>{currentStep}</span>
                            <span className={styles.grayText}>/{4}</span>
                        </div>
                    )}
                    <img
                        src={progressSuccess}
                        style={{
                            filter: progress === 100 ? 'none' : 'grayscale(1)',
                            width: '30px'
                        }}
                    />
                </div>
            </div>
            <div className={styles.progressWrapper}>
                <div className={styles.line} />
                <div className={styles.progress} style={{ width: `${progress}%` }} />
            </div>
        </div>
    )
}

export default NewApplicationProgress